import React from 'react';
import { FileTextIcon, CheckCircleIcon, AlertTriangleIcon, ClockIcon, SearchIcon, ArrowRightIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
const TrusteeManagement = () => {
  return <div data-id="element-3586">
      <div className="mb-6" data-id="element-3587">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-3588">
          Trustee Management System
        </h1>
        <p className="text-neutral-400" data-id="element-3589">
          Monitor fund distribution and ensure compliance
        </p>
      </div>
      {/* Monitoring Dashboard */}
      <section className="mb-8" data-id="element-3590">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3591">
          <Card data-id="element-3592">
            <div className="flex items-center mb-4" data-id="element-3593">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3594">
                <FileTextIcon className="w-5 h-5 text-primary" data-id="element-3595" />
              </div>
              <div data-id="element-3596">
                <h3 className="font-medium" data-id="element-3597">Active Sukuk</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-3598">24</div>
            <div className="text-sm text-neutral-400" data-id="element-3599">Total value: RM 1.2M</div>
          </Card>
          <Card data-id="element-3600">
            <div className="flex items-center mb-4" data-id="element-3601">
              <div className="w-10 h-10 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3602">
                <ClockIcon className="w-5 h-5 text-warning" data-id="element-3603" />
              </div>
              <div data-id="element-3604">
                <h3 className="font-medium" data-id="element-3605">Pending Verifications</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-3606">5</div>
            <div className="text-sm text-neutral-400" data-id="element-3607">Requires action</div>
          </Card>
          <Card data-id="element-3608">
            <div className="flex items-center mb-4" data-id="element-3609">
              <div className="w-10 h-10 rounded-full bg-error bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3610">
                <AlertTriangleIcon className="w-5 h-5 text-error" data-id="element-3611" />
              </div>
              <div data-id="element-3612">
                <h3 className="font-medium" data-id="element-3613">Compliance Alerts</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-3614">2</div>
            <div className="text-sm text-error" data-id="element-3615">
              Requires immediate attention
            </div>
          </Card>
        </div>
      </section>
      {/* Pending Verifications */}
      <section className="mb-8" data-id="element-3616">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4" data-id="element-3617">
          <h2 className="text-xl font-bold" data-id="element-3618">Pending Verifications</h2>
          <div className="relative mt-3 sm:mt-0" data-id="element-3619">
            <input type="text" placeholder="Search by ID or business" className="pl-9 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" data-id="element-3620" />
            <SearchIcon className="w-4 h-4 absolute left-3 top-3 text-neutral-400" data-id="element-3621" />
          </div>
        </div>
        <Card data-id="element-3622">
          <div className="overflow-x-auto" data-id="element-3623">
            <table className="w-full" data-id="element-3624">
              <thead data-id="element-3625">
                <tr className="text-left border-b border-neutral-100" data-id="element-3626">
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3627">ID</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3628">
                    Business
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3629">Type</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3630">Amount</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3631">
                    Requested
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3632">Status</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-3633">Actions</th>
                </tr>
              </thead>
              <tbody data-id="element-3634">
                <tr className="border-b border-neutral-100" data-id="element-3635">
                  <td className="py-3" data-id="element-3636">#VR2001</td>
                  <td className="py-3" data-id="element-3637">GreenTech Solutions</td>
                  <td className="py-3" data-id="element-3638">Fund Disbursement</td>
                  <td className="py-3" data-id="element-3639">RM 15,000</td>
                  <td className="py-3" data-id="element-3640">Today</td>
                  <td className="py-3" data-id="element-3641">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded text-xs font-medium" data-id="element-3642">
                      Pending
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3643">
                    <Button variant="primary" size="sm" data-id="element-3644">
                      Verify
                    </Button>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-3645">
                  <td className="py-3" data-id="element-3646">#VR2002</td>
                  <td className="py-3" data-id="element-3647">Amani Cafe</td>
                  <td className="py-3" data-id="element-3648">Equipment Purchase</td>
                  <td className="py-3" data-id="element-3649">RM 8,500</td>
                  <td className="py-3" data-id="element-3650">Yesterday</td>
                  <td className="py-3" data-id="element-3651">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded text-xs font-medium" data-id="element-3652">
                      Pending
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3653">
                    <Button variant="primary" size="sm" data-id="element-3654">
                      Verify
                    </Button>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-3655">
                  <td className="py-3" data-id="element-3656">#VR2003</td>
                  <td className="py-3" data-id="element-3657">Modest Fashion House</td>
                  <td className="py-3" data-id="element-3658">Inventory Purchase</td>
                  <td className="py-3" data-id="element-3659">RM 22,000</td>
                  <td className="py-3" data-id="element-3660">2 days ago</td>
                  <td className="py-3" data-id="element-3661">
                    <span className="bg-error bg-opacity-10 text-error px-2 py-1 rounded text-xs font-medium" data-id="element-3662">
                      Documentation Missing
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3663">
                    <Button variant="outline" size="sm" data-id="element-3664">
                      Request Docs
                    </Button>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-3665">
                  <td className="py-3" data-id="element-3666">#VR2004</td>
                  <td className="py-3" data-id="element-3667">Tech Innovate</td>
                  <td className="py-3" data-id="element-3668">R&D Expense</td>
                  <td className="py-3" data-id="element-3669">RM 18,000</td>
                  <td className="py-3" data-id="element-3670">Today</td>
                  <td className="py-3" data-id="element-3671">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded text-xs font-medium" data-id="element-3672">
                      Pending
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3673">
                    <Button variant="primary" size="sm" data-id="element-3674">
                      Verify
                    </Button>
                  </td>
                </tr>
                <tr data-id="element-3675">
                  <td className="py-3" data-id="element-3676">#VR2005</td>
                  <td className="py-3" data-id="element-3677">Halal Delights</td>
                  <td className="py-3" data-id="element-3678">Working Capital</td>
                  <td className="py-3" data-id="element-3679">RM 10,000</td>
                  <td className="py-3" data-id="element-3680">Yesterday</td>
                  <td className="py-3" data-id="element-3681">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded text-xs font-medium" data-id="element-3682">
                      Pending
                    </span>
                  </td>
                  <td className="py-3" data-id="element-3683">
                    <Button variant="primary" size="sm" data-id="element-3684">
                      Verify
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </section>
      {/* Compliance Monitoring */}
      <section data-id="element-3685">
        <h2 className="text-xl font-bold mb-4" data-id="element-3686">Compliance Monitoring</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3687">
          <Card data-id="element-3688">
            <div className="flex items-center mb-4" data-id="element-3689">
              <div className="w-10 h-10 rounded-full bg-error bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3690">
                <AlertTriangleIcon className="w-5 h-5 text-error" data-id="element-3691" />
              </div>
              <div data-id="element-3692">
                <h3 className="font-medium" data-id="element-3693">Compliance Alerts</h3>
              </div>
            </div>
            <div className="space-y-4" data-id="element-3694">
              <div className="border border-error border-opacity-20 bg-error bg-opacity-5 rounded-lg p-4" data-id="element-3695">
                <div className="flex justify-between items-start mb-2" data-id="element-3696">
                  <h4 className="font-medium text-error" data-id="element-3697">
                    Fund Usage Deviation
                  </h4>
                  <span className="text-xs text-neutral-400" data-id="element-3698">2 hours ago</span>
                </div>
                <p className="text-sm mb-3" data-id="element-3699">
                  Tech Innovate has allocated funds differently than stated in
                  the proposal.
                </p>
                <div className="flex justify-between items-center" data-id="element-3700">
                  <div className="text-xs text-neutral-400" data-id="element-3701">ID: #SK1025</div>
                  <Button variant="outline" size="sm" className="border-error text-error hover:bg-error hover:text-white" data-id="element-3702">
                    Investigate
                  </Button>
                </div>
              </div>
              <div className="border border-error border-opacity-20 bg-error bg-opacity-5 rounded-lg p-4" data-id="element-3703">
                <div className="flex justify-between items-start mb-2" data-id="element-3704">
                  <h4 className="font-medium text-error" data-id="element-3705">Missing Repayment</h4>
                  <span className="text-xs text-neutral-400" data-id="element-3706">1 day ago</span>
                </div>
                <p className="text-sm mb-3" data-id="element-3707">
                  Halal Delights has missed the scheduled repayment for this
                  month.
                </p>
                <div className="flex justify-between items-center" data-id="element-3708">
                  <div className="text-xs text-neutral-400" data-id="element-3709">ID: #SK1018</div>
                  <Button variant="outline" size="sm" className="border-error text-error hover:bg-error hover:text-white" data-id="element-3710">
                    Follow Up
                  </Button>
                </div>
              </div>
            </div>
          </Card>
          <Card data-id="element-3711">
            <div className="flex items-center mb-4" data-id="element-3712">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3713">
                <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-3714" />
              </div>
              <div data-id="element-3715">
                <h3 className="font-medium" data-id="element-3716">Recent Verifications</h3>
              </div>
            </div>
            <div className="space-y-3" data-id="element-3717">
              <div className="flex items-center p-3 border-b border-neutral-100" data-id="element-3718">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3719">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-3720" />
                </div>
                <div className="flex-1" data-id="element-3721">
                  <div className="font-medium" data-id="element-3722">Amani Cafe</div>
                  <div className="text-xs text-neutral-400" data-id="element-3723">
                    Equipment purchase verified
                  </div>
                </div>
                <div className="text-xs text-neutral-400" data-id="element-3724">2 days ago</div>
              </div>
              <div className="flex items-center p-3 border-b border-neutral-100" data-id="element-3725">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3726">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-3727" />
                </div>
                <div className="flex-1" data-id="element-3728">
                  <div className="font-medium" data-id="element-3729">GreenTech Solutions</div>
                  <div className="text-xs text-neutral-400" data-id="element-3730">
                    Inventory purchase verified
                  </div>
                </div>
                <div className="text-xs text-neutral-400" data-id="element-3731">3 days ago</div>
              </div>
              <div className="flex items-center p-3 border-b border-neutral-100" data-id="element-3732">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3733">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-3734" />
                </div>
                <div className="flex-1" data-id="element-3735">
                  <div className="font-medium" data-id="element-3736">Modest Fashion House</div>
                  <div className="text-xs text-neutral-400" data-id="element-3737">
                    Store lease payment verified
                  </div>
                </div>
                <div className="text-xs text-neutral-400" data-id="element-3738">4 days ago</div>
              </div>
              <div className="flex items-center p-3" data-id="element-3739">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-3740">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-3741" />
                </div>
                <div className="flex-1" data-id="element-3742">
                  <div className="font-medium" data-id="element-3743">Tech Innovate</div>
                  <div className="text-xs text-neutral-400" data-id="element-3744">
                    R&D equipment verified
                  </div>
                </div>
                <div className="text-xs text-neutral-400" data-id="element-3745">5 days ago</div>
              </div>
            </div>
            <div className="mt-4 text-center" data-id="element-3746">
              <Button variant="ghost" size="sm" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-3748" />} iconPosition="right" data-id="element-3747">
                View All Verifications
              </Button>
            </div>
          </Card>
        </div>
      </section>
    </div>;
};
export default TrusteeManagement;